// extracted by mini-css-extract-plugin
export default {"container":"DefautPage_container__q2Ds0","container--dark":"DefautPage_container--dark__K6YgP"};